import { useQuery } from '@tanstack/react-query';
import { countriesQuery, facilitiesQuery } from './queries';

export function useFacilities(countryCode: string) {
  return useQuery(facilitiesQuery(countryCode));
}

export function useCountries() {
  return useQuery(countriesQuery());
}
